import React from "react";
import PropTypes from "prop-types";
import { Controller } from "react-hook-form";
import { Checkbox, FormControlLabel } from "@mui/material";

function FileDataReadingConfirmationCheckbox({ control }) {
  return (
    <Controller
      name="readingConfirmation"
      control={control}
      render={({ field }) => (
        <FormControlLabel
          control={<Checkbox {...field} checked={field.value} />}
          label="Lesebestätigung"
        />
      )}
    />
  );
}

FileDataReadingConfirmationCheckbox.propTypes = {
  control: PropTypes.object,
};

export default FileDataReadingConfirmationCheckbox;
